(function ($) {
  $(function () {
    const faqCategory = $(".js-faq-category");
    
    if (!faqCategory.length) {
      return;
    }

    const input = $(".js-faq-search");
    const accordionToggle = $(".js-accordion-toggle");
    const selectedClass = "is-selected";

    initDefaultState();

    input.on("keypress", function (e) {
      return e.which !== 13;
    });


    faqCategory.on("click", function (e) {
      e.preventDefault();

      faqCategory.removeClass(selectedClass);

      $(this).addClass(selectedClass);

      var selectedCategory = $(this).attr("data-category-id");
      loadSelectedCategory(selectedCategory);
    });


    input.on("input keyup paste", function () {
      searchInFaqs();
    });


    function initDefaultState() {
      const firstCategory = faqCategory.first();
      const firstCategoryID = firstCategory.attr("data-category-id");

      firstCategory.addClass(selectedClass);
      loadSelectedCategory(firstCategoryID);
    }


    function loadSelectedCategory(selectedCategory) {
      accordionToggle.each(function () {
        var categories = $(this).attr("data-categories");

        if (categories.includes(selectedCategory)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }

    function searchInFaqs() {
      toggleCategoryVisibility();

      const searchValue = input.val().toLowerCase().trim();

      accordionToggle.each(function () {
        const question = $(this).find(".js-faq-title").text().toLowerCase();
        const answer = $(this).find(".js-accordion-body").text().toLowerCase();

        if (question.includes(searchValue) || answer.includes(searchValue)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });


      function toggleCategoryVisibility() {
        if (input.val() != "") {
          faqCategory.hide();
        } else {
          faqCategory.show();
        }
      }
    }
  });
})(jQuery);
